import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getLinkMeta({ payload: { values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.links.get_meta, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.getLinkMetaDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLinkMetaFailed,
      onError,
      handledErrors,
      endpoint: api.links.get_meta.url
    });
  }
}

export const getLinkMetaSaga = takeEvery(types.GET_LINK_META_REQUEST, getLinkMeta);